import React, { useState, useEffect } from 'react';
import DeleteAttachment from './DeleteAttachment';
import { Accordion, AccordionSummary, Tooltip } from '@material-ui/core';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import PdfComponent from './PdfComponent';
import { useTranslation } from 'react-i18next';
import ToggleSignatureButton from './ToggleSignatureButton';
import { useTour } from '@reactour/tour';
import { tourSteps } from '../../TourSteps';

const useStyles = makeStyles(() => ({
  root: {
    background: 'transparent',
    borderBottom: '1px solid #D1D1D1',
    boxShadow: 'none',
    '&::before': {
      backgroundColor: 'transparent'
    },
    '& > .Mui-expanded': {
      borderTop: '0px',
      borderRight: '0px',
      borderLeft: '0px',
      border: '10px solid white'
    }
  },
  expanded: {
    backgroundColor: '#E5E5E5'
  },
  content: {
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  containerPdf: {
    width: '100%',
    position: 'relative',
    minHeight: 1403,
    overflowY: 'auto',
    overflowX: 'hidden'
  }
}));

function PdfListFromDocument ({
  pdfSignedUrl,
  filesName,
  downloadMainDocument,
  renderUploadBtn,
  downloadAnnexeFile,
  input,
  getData,
  type
}) {
  const { isOpen, setIsOpen, setCurrentStep, setSteps, currentStep } = useTour();
  const [expanded, setExpanded] = useState(0);

  const MainDocument = 0;
  const { t } = useTranslation();
  const classes = useStyles();

  useEffect(() => {
    const tour = JSON.parse(localStorage.getItem('tour-document'));
    setSteps(tourSteps.document);
    setCurrentStep(0);
    setIsOpen(tour);
  }, []);
  useEffect(() => {
    if (isOpen && currentStep === 3) {
      setExpanded(0);
    }
  }, [currentStep]);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    pdfSignedUrl.map((url, i) =>
      <Accordion
        expanded={expanded === i}
        onChange={handleChange(i)}
        key={i}
        classes={{ root: classes.root, expanded: classes.expanded }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon className='document-expandDocument' />}
          aria-controls='panel1a-content'
          id='panel1a-header'
          classes={{ content: classes.content }}
        >
          <Typography>{filesName[i]}</Typography>
          <div>
            {i === MainDocument
              ? (
                <>
                  <Tooltip disableFocusListener title={t('viewer:downloadDocument')}>
                    <IconButton
                      className='document-downloadDocument'
                      onClick={() => downloadMainDocument(url)}
                      style={{ color: 'black' }}>
                      <SaveAltIcon style={{ fontSize: '18px' }} />
                    </IconButton>
                  </Tooltip>
                  {renderUploadBtn(i)}
                </>
              ) : (
                <>
                  <DeleteAttachment index={i - 1} input={input} getData={getData} />
                  <Tooltip disableFocusListener title={t('viewer:downloadDocument')}>
                    <IconButton onClick={downloadAnnexeFile(url.original)} style={{ color: 'black' }}>
                      <SaveAltIcon style={{ fontSize: '18px' }} />
                    </IconButton>
                  </Tooltip>
                  <ToggleSignatureButton input={input} index={i} />
                </>
              )
            }
          </div>
        </AccordionSummary>
        <AccordionDetails id='scroll'>
          <div className={classes.containerPdf}>
            {expanded === i && <PdfComponent url={url.url} index={i} item={input} type={type} />}
          </div>
        </AccordionDetails>
      </Accordion>
    )
  );
}

export default PdfListFromDocument;
